// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 1l4 4 4-4%27 stroke=%27%239ca3af%27 fill=%27none%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: rgba(10, 10, 10, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  z-index: 1000;
  display: flex;
  align-items: center;
}

.top-nav--hidden {
  display: none;
}

.top-nav-container {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

.top-nav-left {
  display: flex;
  align-items: center;
  position: relative;
}

.logo-container {
  position: relative;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  text-decoration: none;
  transition: opacity 0.2s ease;
  padding: 0.25rem 0;
  cursor: pointer;
}

.logo-link:hover {
  opacity: 0.85;
}

.logo-dropdown-arrow {
  margin-left: 0.25rem;
  color: #9ca3af;
  transition: transform 0.2s ease;
}

.logo-link:hover .logo-dropdown-arrow {
  color: #ffffff;
}

.logo-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  min-width: 180px;
  background: rgba(20, 20, 20, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  z-index: 1001;
  animation: dropdownFadeIn 0.15s ease-out;
}

.logo-dropdown-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.875rem 1rem;
  background: none;
  border: none;
  color: #9ca3af;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;
}

.logo-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
}

.logo-dropdown-item.active {
  background: rgba(239, 68, 68, 0.1);
  color: #f87171;
}

.logo-dropdown-label {
  flex: 1 1;
}

.logo-dropdown-badge {
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  border-radius: 9999px;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.4);
  color: #f87171;
}

.logo-dropdown-badge.ap {
  background: rgba(139, 92, 246, 0.15);
  border: 1px solid rgba(139, 92, 246, 0.4);
  color: #a78bfa;
}

.logo-bono {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: 0.28em;
  color: #ffffff;
  text-transform: uppercase;
  line-height: 1;
}

.logo-favicon {
  height: 32px;
  width: 32px;
  display: block;
  object-fit: contain;
}

.logo-rx-pill {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #f87171;
  background: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.4);
  border-radius: 9999px;
  padding: 0.25rem 0.6rem;
  margin-left: 0.5rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}


.top-nav-center {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.nav-link {
  color: #9ca3af;
  text-decoration: none;
  font-weight: 500;
  font-size: 0.9375rem;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  position: relative;
}

.nav-link:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.05);
}

.nav-link--locked {
  opacity: 0.35;
  cursor: not-allowed;
}

.nav-link--locked:hover {
  color: #9ca3af;
  background: none;
}

.nav-link.active {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
}

.nav-link.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 2px;
  background: #ffffff;
  border-radius: 1px;
  margin-bottom: -10px;
}

.top-nav-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.profile-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.05);
}

.profile-icon:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

/* Profile Button */
.profile-button {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.nav-actions {
  position: relative;
}

/* Profile Dropdown */
.profile-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 220px;
  background: rgba(20, 20, 20, 0.98);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  z-index: 1001;
  animation: dropdownFadeIn 0.15s ease-out;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dropdown-header {
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.dropdown-email {
  color: #e5e7eb;
  font-size: 0.875rem;
  font-weight: 500;
  word-break: break-all;
}

.dropdown-role {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  width: fit-content;
}

.dropdown-role.role-admin {
  background: rgba(168, 85, 247, 0.2);
  color: #c084fc;
  border: 1px solid rgba(168, 85, 247, 0.3);
}

.dropdown-role.role-premium {
  background: rgba(234, 179, 8, 0.2);
  color: #fbbf24;
  border: 1px solid rgba(234, 179, 8, 0.3);
}

.dropdown-role.role-base {
  background: rgba(107, 114, 128, 0.2);
  color: #9ca3af;
  border: 1px solid rgba(107, 114, 128, 0.3);
}

.dropdown-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin: 0;
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.875rem 1rem;
  background: none;
  border: none;
  color: #9ca3af;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;
}

.dropdown-item:hover {
  background: rgba(255, 255, 255, 0.05);
  color: #ffffff;
}

.dropdown-item.logout-item:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #f87171;
}

.dropdown-item.switch-mode-item:hover {
  background: rgba(59, 130, 246, 0.1);
  color: #60a5fa;
}

.dropdown-item svg {
  flex-shrink: 0;
}

/* Mode indicator in dropdown */
.dropdown-mode {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  width: fit-content;
  margin-top: 0.25rem;
}

.dropdown-mode.mode-admin {
  background: rgba(239, 68, 68, 0.15);
  color: #f87171;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

.dropdown-mode.mode-base {
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
  border: 1px solid rgba(59, 130, 246, 0.3);
}

/* Help Codex Nav Button */
.help-codex-nav-button {
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  padding: 0;
  flex-shrink: 0;
}

.help-codex-nav-button:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

/* Settings Nav Button */
.settings-nav-button {
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  padding: 0;
  flex-shrink: 0;
}

.settings-nav-button:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

.settings-nav-button svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Upgrade Button */
.upgrade-button {
  display: inline-block;
  padding: 5px 8px;
  background: rgba(59, 130, 246, 0.12);
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 4px;
  color: #60a5fa;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 150ms ease;
  margin-right: 0.75rem;
  flex-shrink: 0;
}

.upgrade-button:hover {
  background: rgba(59, 130, 246, 0.2);
  border-color: rgba(59, 130, 246, 0.35);
  color: #93c5fd;
}

.upgrade-button:active {
  opacity: 0.8;
}

/* Subscription Badge — matches admin au-badge styling */
.premium-badge {
  display: inline-block;
  padding: 5px 8px;
  background: rgba(251, 191, 36, 0.1);
  border: 1px solid rgba(251, 191, 36, 0.2);
  border-radius: 4px;
  color: #fbbf24;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  margin-right: 0.75rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Dev Portal toggle — owner verifier topbar surface, distinct from the
   floating partner_admin tile in AdminLayout. Red EKG accent. */
.dev-portal-nav-button {
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: rgba(239, 68, 68, 0.85);
  cursor: pointer;
  transition: all 0.15s ease;
  background: rgba(239, 68, 68, 0.06);
  border: 1px solid rgba(239, 68, 68, 0.28);
  padding: 0;
  flex-shrink: 0;
  text-decoration: none;
}
.dev-portal-nav-button:hover {
  color: rgba(255, 110, 110, 1);
  background: rgba(239, 68, 68, 0.14);
  border-color: rgba(239, 68, 68, 0.5);
}
.dev-portal-nav-button svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  filter: drop-shadow(0 0 3px rgba(239, 68, 68, 0.45));
  transition: filter 150ms ease;
}
.dev-portal-nav-button:hover svg {
  filter: drop-shadow(0 0 5px rgba(239, 68, 68, 0.7));
}

/* Feature Request Nav Button */
.feature-request-nav-button {
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  padding: 0;
  flex-shrink: 0;
}

.feature-request-nav-button:hover {
  color: #fbbf24;
  background: rgba(251, 191, 36, 0.1);
}

.feature-request-nav-button svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* Bug Report Nav Button */
.bug-report-nav-button {
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  padding: 0;
  flex-shrink: 0;
}

.bug-report-nav-button:hover {
  color: #fb923c;
  background: rgba(251, 146, 60, 0.1);
}

.bug-report-nav-button svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

/* ===================== Bug Report Modal ===================== */
.bug-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: bugOverlayIn 0.15s ease-out;
}

@keyframes bugOverlayIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.bug-modal {
  background: #141414;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  width: 90%;
  max-width: 440px;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);
  animation: bugModalIn 0.2s ease-out;
  overflow: hidden;
}

@keyframes bugModalIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.bug-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.bug-modal-header h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #f3f4f6;
}

.bug-modal-close {
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
}

.bug-modal-close:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
}

.bug-modal-form {
  padding: 1.25rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.bug-form-group {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}

.bug-form-group label {
  font-size: 0.8rem;
  font-weight: 500;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.bug-form-group input,
.bug-form-group textarea,
.bug-form-group select {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 0.625rem 0.75rem;
  color: #e5e7eb;
  font-size: 0.875rem;
  font-family: inherit;
  transition: border-color 0.15s ease;
  outline: none;
}

.bug-form-group input:focus,
.bug-form-group textarea:focus,
.bug-form-group select:focus {
  border-color: rgba(251, 146, 60, 0.5);
}

.bug-form-group textarea {
  resize: vertical;
  min-height: 80px;
}

.bug-form-group select {
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  padding-right: 2rem;
}

.bug-form-group select option {
  background: #1a1a1a;
  color: #e5e7eb;
}

.bug-form-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.5rem;
}

.bug-form-page {
  font-size: 0.75rem;
  color: #6b7280;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bug-submit-btn {
  padding: 0.5rem 1.25rem;
  background: rgba(251, 146, 60, 0.15);
  border: 1px solid rgba(251, 146, 60, 0.3);
  border-radius: 8px;
  color: #fb923c;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.bug-submit-btn:hover:not(:disabled) {
  background: rgba(251, 146, 60, 0.25);
  border-color: rgba(251, 146, 60, 0.5);
  color: #fdba74;
}

.bug-submit-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.bug-modal-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 3rem 2rem;
}

.bug-modal-success p {
  color: #22c55e;
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
}

/* Bug Type Toggle */
.bug-type-toggle {
  display: flex;
  gap: 0.5rem;
}

.bug-type-btn {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.5rem 0.75rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 7px;
  color: #9ca3af;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.bug-type-btn:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #d1d5db;
}

.bug-type-btn.active {
  background: rgba(251, 146, 60, 0.12);
  border-color: rgba(251, 146, 60, 0.4);
  color: #fb923c;
}

/* Quick Labels (question context mode) */
.bug-quick-labels {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.bug-quick-label {
  padding: 0.35rem 0.65rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  color: #9ca3af;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.12s ease;
  font-family: inherit;
}

.bug-quick-label:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #d1d5db;
}

.bug-quick-label.active {
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(239, 68, 68, 0.4);
  color: #f87171;
}

/* Screenshot Upload */
.bug-screenshot-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  padding: 0.6rem 0.85rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px dashed rgba(255, 255, 255, 0.15);
  border-radius: 7px;
  color: #9ca3af;
  font-size: 0.8rem;
  cursor: pointer;
  transition: all 0.15s ease;
}

.bug-screenshot-btn:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.25);
  color: #d1d5db;
}

.bug-screenshot-preview {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 7px;
  overflow: hidden;
}

.bug-screenshot-preview img {
  width: 100%;
  max-height: 120px;
  object-fit: cover;
  display: block;
}

.bug-screenshot-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.35rem 0.6rem;
  background: rgba(255, 255, 255, 0.03);
}

.bug-screenshot-name {
  font-size: 0.7rem;
  color: #6b7280;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}

.bug-screenshot-remove {
  padding: 0.2rem;
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s;
}

.bug-screenshot-remove:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

/* ===================== Bug Report Question Context ===================== */
.bug-question-context {
  margin: 0 1.25rem;
  border: 1px solid rgba(96, 165, 250, 0.2);
  border-radius: 8px;
  background: rgba(96, 165, 250, 0.05);
  overflow: hidden;
}

.bug-question-context-header {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.45rem 0.75rem;
  background: rgba(96, 165, 250, 0.08);
  font-size: 0.75rem;
  font-weight: 600;
  color: #60a5fa;
}

.bug-question-context-remove {
  margin-left: auto;
  padding: 0.15rem;
  background: none;
  border: none;
  color: #6b7280;
  cursor: pointer;
  border-radius: 3px;
  transition: all 0.15s;
}

.bug-question-context-remove:hover {
  color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.bug-question-context-body {
  padding: 0.6rem 0.75rem;
}

.bug-question-text {
  font-size: 0.8rem;
  color: #e5e7eb;
  margin: 0 0 0.4rem;
  line-height: 1.4;
}

.bug-question-type-tag {
  display: inline-block;
  padding: 0.1rem 0.4rem;
  font-size: 0.65rem;
  font-weight: 600;
  color: #60a5fa;
  background: rgba(96, 165, 250, 0.1);
  border: 1px solid rgba(96, 165, 250, 0.2);
  border-radius: 4px;
  margin-bottom: 0.4rem;
}

.bug-question-options {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.3rem;
}

.bug-question-option {
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
  padding: 0.25rem 0.4rem;
  border-radius: 5px;
  font-size: 0.75rem;
  color: #9ca3af;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.bug-question-option.correct {
  background: rgba(34, 197, 94, 0.08);
  border-color: rgba(34, 197, 94, 0.2);
  color: #22c55e;
}

.bug-question-option.wrong {
  background: rgba(239, 68, 68, 0.08);
  border-color: rgba(239, 68, 68, 0.2);
  color: #ef4444;
}

.bug-question-option-letter {
  font-weight: 700;
  min-width: 1rem;
  flex-shrink: 0;
}

.bug-question-meta {
  margin-top: 0.35rem;
  font-size: 0.72rem;
  color: #6b7280;
}

.bug-q-correct { color: #22c55e; }
.bug-q-incorrect { color: #ef4444; }

/* ===================== Hamburger Button ===================== */
.hamburger-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 44px;
  height: 44px;
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  gap: 5px;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
}

.hamburger-line {
  display: block;
  width: 20px;
  height: 2px;
  background: currentColor;
  border-radius: 1px;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

/* Animate to X when open */
.hamburger-btn.open .hamburger-line:nth-child(1) {
  transform: translateY(7px) rotate(45deg);
}

.hamburger-btn.open .hamburger-line:nth-child(2) {
  opacity: 0;
}

.hamburger-btn.open .hamburger-line:nth-child(3) {
  transform: translateY(-7px) rotate(-45deg);
}

/* ===================== Mobile Menu Backdrop ===================== */
.mobile-menu-backdrop {
  display: none;
}

/* ===================== Mobile-Only Elements ===================== */
.mobile-menu-only {
  display: none;
}

/* ===================== Mobile Responsive ===================== */
@media (max-width: 768px) {
  .top-nav-container {
    padding: 0 1rem;
  }

  .hamburger-btn {
    display: flex;
  }

  .logo-bono {
    display: none;
  }

  .mobile-menu-only {
    display: flex;
  }

  .top-nav-center {
    position: fixed;
    inset: 0;
    top: 64px;
    background: rgba(10, 10, 10, 0.98);
    backdrop-filter: blur(20px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);
    flex-direction: column;
    padding: 1.5rem;
    padding-bottom: 1rem;
    gap: 0.5rem;
    z-index: 999;
    display: none;
    margin-left: 0;
    justify-content: flex-start;
    align-items: stretch;
    bottom: auto;
  }

  .top-nav-center.mobile-menu-open {
    display: flex;
  }

  .nav-link {
    min-height: 48px;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    font-size: 1.1rem;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 0;
  }

  .nav-link svg {
    color: #6b7280;
    flex-shrink: 0;
  }

  .nav-link.active::after {
    display: none;
  }

  .mobile-menu-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    top: 64px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 998;
  }

  .upgrade-button,
  .premium-badge {
    padding: 0.4rem 0.6rem;
    font-size: 0.75rem;
    margin-right: 0.25rem;
  }

  .bug-report-nav-button {
    width: 32px;
    height: 32px;
    min-width: 32px;
    min-height: 32px;
  }

  .bug-report-nav-button svg {
    width: 16px;
    height: 16px;
  }
}

/* ─── Septyx dev admin entry (dev4 only) ─────────── */
.nav-link--septyx {
  position: relative;
  color: rgba(239, 68, 68, 0.9) !important;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.nav-link--septyx::before {
  content: '';
  position: absolute;
  left: 6px;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(239, 68, 68, 0.9);
  box-shadow: 0 0 6px rgba(239, 68, 68, 0.7);
}

.nav-link--septyx {
  padding-left: 18px !important;
}

.nav-link--septyx:hover {
  color: rgba(254, 202, 202, 1) !important;
  background: rgba(239, 68, 68, 0.08);
}

.nav-link--septyx.active {
  color: rgba(254, 202, 202, 1) !important;
  background: rgba(239, 68, 68, 0.12);
  border-color: rgba(239, 68, 68, 0.4);
}
`, "",{"version":3,"sources":["webpack://./src/components/TopNav.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,kCAAkC;EAClC,2BAA2B;EAC3B,kDAAkD;EAClD,aAAa;EACb,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,gBAAgB;EAChB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,gFAAgF;EAChF,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gFAAgF;EAChF,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,wCAAwC;EACxC,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,gBAAgB;EAChB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA,wDAAwD;AACxD;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;gEACgE;AAChE;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,yCAAyC;EACzC,UAAU;EACV,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,oDAAoD;EACpD,6BAA6B;AAC/B;AACA;EACE,mDAAmD;AACrD;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qCAAqC;EACrC,YAAY;EACZ,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,mCAAmC;EACnC,aAAa;AACf;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yDAAwQ;EACxQ,4BAA4B;EAC5B,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,qCAAqC;EACrC,4CAA4C;EAC5C,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,4EAA4E;AAC5E;EACE,iBAAiB;EACjB,yCAAyC;EACzC,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,iBAAiB,cAAc,EAAE;AACjC,mBAAmB,cAAc,EAAE;;AAEnC,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,QAAQ;EACR,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA,2BAA2B;AAC3B;EACE,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,qEAAqE;AACrE;EACE,aAAa;AACf;;AAEA,qEAAqE;AACrE;EACE,aAAa;AACf;;AAEA,kEAAkE;AAClE;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,SAAS;IACT,kCAAkC;IAClC,2BAA2B;IAC3B,kDAAkD;IAClD,yCAAyC;IACzC,sBAAsB;IACtB,eAAe;IACf,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,cAAc;IACd,2BAA2B;IAC3B,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,kDAAkD;IAClD,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,YAAY;EACd;;EAEA;;IAEE,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,mCAAmC;EACnC,oCAAoC;AACtC","sourcesContent":[".top-nav {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 64px;\n  background: rgba(10, 10, 10, 0.95);\n  backdrop-filter: blur(10px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n}\n\n.top-nav--hidden {\n  display: none;\n}\n\n.top-nav-container {\n  width: 100%;\n  max-width: 100%;\n  margin: 0 auto;\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 100%;\n}\n\n.top-nav-left {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.logo-container {\n  position: relative;\n}\n\n.logo-link {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  text-decoration: none;\n  transition: opacity 0.2s ease;\n  padding: 0.25rem 0;\n  cursor: pointer;\n}\n\n.logo-link:hover {\n  opacity: 0.85;\n}\n\n.logo-dropdown-arrow {\n  margin-left: 0.25rem;\n  color: #9ca3af;\n  transition: transform 0.2s ease;\n}\n\n.logo-link:hover .logo-dropdown-arrow {\n  color: #ffffff;\n}\n\n.logo-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 0;\n  min-width: 180px;\n  background: rgba(20, 20, 20, 0.98);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n  z-index: 1001;\n  animation: dropdownFadeIn 0.15s ease-out;\n}\n\n.logo-dropdown-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0.875rem 1rem;\n  background: none;\n  border: none;\n  color: #9ca3af;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  text-align: left;\n}\n\n.logo-dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n}\n\n.logo-dropdown-item.active {\n  background: rgba(239, 68, 68, 0.1);\n  color: #f87171;\n}\n\n.logo-dropdown-label {\n  flex: 1;\n}\n\n.logo-dropdown-badge {\n  font-size: 0.7rem;\n  font-weight: 600;\n  padding: 0.2rem 0.5rem;\n  border-radius: 9999px;\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  color: #f87171;\n}\n\n.logo-dropdown-badge.ap {\n  background: rgba(139, 92, 246, 0.15);\n  border: 1px solid rgba(139, 92, 246, 0.4);\n  color: #a78bfa;\n}\n\n.logo-bono {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: 0.28em;\n  color: #ffffff;\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n.logo-favicon {\n  height: 32px;\n  width: 32px;\n  display: block;\n  object-fit: contain;\n}\n\n.logo-rx-pill {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #f87171;\n  background: rgba(239, 68, 68, 0.15);\n  border: 1px solid rgba(239, 68, 68, 0.4);\n  border-radius: 9999px;\n  padding: 0.25rem 0.6rem;\n  margin-left: 0.5rem;\n  line-height: 1;\n  display: inline-flex;\n  align-items: center;\n}\n\n\n.top-nav-center {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.nav-link {\n  color: #9ca3af;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 0.9375rem;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.nav-link:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.nav-link--locked {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.nav-link--locked:hover {\n  color: #9ca3af;\n  background: none;\n}\n\n.nav-link.active {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.nav-link.active::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 20px;\n  height: 2px;\n  background: #ffffff;\n  border-radius: 1px;\n  margin-bottom: -10px;\n}\n\n.top-nav-right {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.nav-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.profile-icon {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.profile-icon:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Profile Button */\n.profile-button {\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.nav-actions {\n  position: relative;\n}\n\n/* Profile Dropdown */\n.profile-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 220px;\n  background: rgba(20, 20, 20, 0.98);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n  z-index: 1001;\n  animation: dropdownFadeIn 0.15s ease-out;\n}\n\n@keyframes dropdownFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.dropdown-header {\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.dropdown-email {\n  color: #e5e7eb;\n  font-size: 0.875rem;\n  font-weight: 500;\n  word-break: break-all;\n}\n\n.dropdown-role {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  width: fit-content;\n}\n\n.dropdown-role.role-admin {\n  background: rgba(168, 85, 247, 0.2);\n  color: #c084fc;\n  border: 1px solid rgba(168, 85, 247, 0.3);\n}\n\n.dropdown-role.role-premium {\n  background: rgba(234, 179, 8, 0.2);\n  color: #fbbf24;\n  border: 1px solid rgba(234, 179, 8, 0.3);\n}\n\n.dropdown-role.role-base {\n  background: rgba(107, 114, 128, 0.2);\n  color: #9ca3af;\n  border: 1px solid rgba(107, 114, 128, 0.3);\n}\n\n.dropdown-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.08);\n  margin: 0;\n}\n\n.dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.875rem 1rem;\n  background: none;\n  border: none;\n  color: #9ca3af;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  text-align: left;\n}\n\n.dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  color: #ffffff;\n}\n\n.dropdown-item.logout-item:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: #f87171;\n}\n\n.dropdown-item.switch-mode-item:hover {\n  background: rgba(59, 130, 246, 0.1);\n  color: #60a5fa;\n}\n\n.dropdown-item svg {\n  flex-shrink: 0;\n}\n\n/* Mode indicator in dropdown */\n.dropdown-mode {\n  display: inline-block;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  width: fit-content;\n  margin-top: 0.25rem;\n}\n\n.dropdown-mode.mode-admin {\n  background: rgba(239, 68, 68, 0.15);\n  color: #f87171;\n  border: 1px solid rgba(239, 68, 68, 0.3);\n}\n\n.dropdown-mode.mode-base {\n  background: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n  border: 1px solid rgba(59, 130, 246, 0.3);\n}\n\n/* Help Codex Nav Button */\n.help-codex-nav-button {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.05);\n  border: none;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.help-codex-nav-button:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n/* Settings Nav Button */\n.settings-nav-button {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.05);\n  border: none;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.settings-nav-button:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.settings-nav-button svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n/* Upgrade Button */\n.upgrade-button {\n  display: inline-block;\n  padding: 5px 8px;\n  background: rgba(59, 130, 246, 0.12);\n  border: 1px solid rgba(59, 130, 246, 0.2);\n  border-radius: 4px;\n  color: #60a5fa;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: all 150ms ease;\n  margin-right: 0.75rem;\n  flex-shrink: 0;\n}\n\n.upgrade-button:hover {\n  background: rgba(59, 130, 246, 0.2);\n  border-color: rgba(59, 130, 246, 0.35);\n  color: #93c5fd;\n}\n\n.upgrade-button:active {\n  opacity: 0.8;\n}\n\n/* Subscription Badge — matches admin au-badge styling */\n.premium-badge {\n  display: inline-block;\n  padding: 5px 8px;\n  background: rgba(251, 191, 36, 0.1);\n  border: 1px solid rgba(251, 191, 36, 0.2);\n  border-radius: 4px;\n  color: #fbbf24;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  margin-right: 0.75rem;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Dev Portal toggle — owner verifier topbar surface, distinct from the\n   floating partner_admin tile in AdminLayout. Red EKG accent. */\n.dev-portal-nav-button {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: rgba(239, 68, 68, 0.85);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  background: rgba(239, 68, 68, 0.06);\n  border: 1px solid rgba(239, 68, 68, 0.28);\n  padding: 0;\n  flex-shrink: 0;\n  text-decoration: none;\n}\n.dev-portal-nav-button:hover {\n  color: rgba(255, 110, 110, 1);\n  background: rgba(239, 68, 68, 0.14);\n  border-color: rgba(239, 68, 68, 0.5);\n}\n.dev-portal-nav-button svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n  filter: drop-shadow(0 0 3px rgba(239, 68, 68, 0.45));\n  transition: filter 150ms ease;\n}\n.dev-portal-nav-button:hover svg {\n  filter: drop-shadow(0 0 5px rgba(239, 68, 68, 0.7));\n}\n\n/* Feature Request Nav Button */\n.feature-request-nav-button {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.05);\n  border: none;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.feature-request-nav-button:hover {\n  color: #fbbf24;\n  background: rgba(251, 191, 36, 0.1);\n}\n\n.feature-request-nav-button svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n/* Bug Report Nav Button */\n.bug-report-nav-button {\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: rgba(255, 255, 255, 0.05);\n  border: none;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.bug-report-nav-button:hover {\n  color: #fb923c;\n  background: rgba(251, 146, 60, 0.1);\n}\n\n.bug-report-nav-button svg {\n  width: 18px;\n  height: 18px;\n  flex-shrink: 0;\n}\n\n/* ===================== Bug Report Modal ===================== */\n.bug-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.6);\n  backdrop-filter: blur(4px);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: bugOverlayIn 0.15s ease-out;\n}\n\n@keyframes bugOverlayIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.bug-modal {\n  background: #141414;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  width: 90%;\n  max-width: 440px;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);\n  animation: bugModalIn 0.2s ease-out;\n  overflow: hidden;\n}\n\n@keyframes bugModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.bug-modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.bug-modal-header h3 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #f3f4f6;\n}\n\n.bug-modal-close {\n  background: none;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s ease;\n}\n\n.bug-modal-close:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.bug-modal-form {\n  padding: 1.25rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.bug-form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.375rem;\n}\n\n.bug-form-group label {\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: #9ca3af;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.bug-form-group input,\n.bug-form-group textarea,\n.bug-form-group select {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 0.625rem 0.75rem;\n  color: #e5e7eb;\n  font-size: 0.875rem;\n  font-family: inherit;\n  transition: border-color 0.15s ease;\n  outline: none;\n}\n\n.bug-form-group input:focus,\n.bug-form-group textarea:focus,\n.bug-form-group select:focus {\n  border-color: rgba(251, 146, 60, 0.5);\n}\n\n.bug-form-group textarea {\n  resize: vertical;\n  min-height: 80px;\n}\n\n.bug-form-group select {\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%239ca3af' fill='none' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 0.75rem center;\n  padding-right: 2rem;\n}\n\n.bug-form-group select option {\n  background: #1a1a1a;\n  color: #e5e7eb;\n}\n\n.bug-form-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 0.5rem;\n}\n\n.bug-form-page {\n  font-size: 0.75rem;\n  color: #6b7280;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.bug-submit-btn {\n  padding: 0.5rem 1.25rem;\n  background: rgba(251, 146, 60, 0.15);\n  border: 1px solid rgba(251, 146, 60, 0.3);\n  border-radius: 8px;\n  color: #fb923c;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.bug-submit-btn:hover:not(:disabled) {\n  background: rgba(251, 146, 60, 0.25);\n  border-color: rgba(251, 146, 60, 0.5);\n  color: #fdba74;\n}\n\n.bug-submit-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.bug-modal-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 3rem 2rem;\n}\n\n.bug-modal-success p {\n  color: #22c55e;\n  font-size: 1rem;\n  font-weight: 500;\n  margin: 0;\n}\n\n/* Bug Type Toggle */\n.bug-type-toggle {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.bug-type-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.4rem;\n  padding: 0.5rem 0.75rem;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 7px;\n  color: #9ca3af;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.bug-type-btn:hover {\n  background: rgba(255, 255, 255, 0.06);\n  color: #d1d5db;\n}\n\n.bug-type-btn.active {\n  background: rgba(251, 146, 60, 0.12);\n  border-color: rgba(251, 146, 60, 0.4);\n  color: #fb923c;\n}\n\n/* Quick Labels (question context mode) */\n.bug-quick-labels {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.bug-quick-label {\n  padding: 0.35rem 0.65rem;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  color: #9ca3af;\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.12s ease;\n  font-family: inherit;\n}\n\n.bug-quick-label:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: #d1d5db;\n}\n\n.bug-quick-label.active {\n  background: rgba(239, 68, 68, 0.12);\n  border-color: rgba(239, 68, 68, 0.4);\n  color: #f87171;\n}\n\n/* Screenshot Upload */\n.bug-screenshot-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  width: 100%;\n  padding: 0.6rem 0.85rem;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px dashed rgba(255, 255, 255, 0.15);\n  border-radius: 7px;\n  color: #9ca3af;\n  font-size: 0.8rem;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.bug-screenshot-btn:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.25);\n  color: #d1d5db;\n}\n\n.bug-screenshot-preview {\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 7px;\n  overflow: hidden;\n}\n\n.bug-screenshot-preview img {\n  width: 100%;\n  max-height: 120px;\n  object-fit: cover;\n  display: block;\n}\n\n.bug-screenshot-info {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.35rem 0.6rem;\n  background: rgba(255, 255, 255, 0.03);\n}\n\n.bug-screenshot-name {\n  font-size: 0.7rem;\n  color: #6b7280;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 200px;\n}\n\n.bug-screenshot-remove {\n  padding: 0.2rem;\n  background: none;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.15s;\n}\n\n.bug-screenshot-remove:hover {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n/* ===================== Bug Report Question Context ===================== */\n.bug-question-context {\n  margin: 0 1.25rem;\n  border: 1px solid rgba(96, 165, 250, 0.2);\n  border-radius: 8px;\n  background: rgba(96, 165, 250, 0.05);\n  overflow: hidden;\n}\n\n.bug-question-context-header {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.45rem 0.75rem;\n  background: rgba(96, 165, 250, 0.08);\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #60a5fa;\n}\n\n.bug-question-context-remove {\n  margin-left: auto;\n  padding: 0.15rem;\n  background: none;\n  border: none;\n  color: #6b7280;\n  cursor: pointer;\n  border-radius: 3px;\n  transition: all 0.15s;\n}\n\n.bug-question-context-remove:hover {\n  color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.bug-question-context-body {\n  padding: 0.6rem 0.75rem;\n}\n\n.bug-question-text {\n  font-size: 0.8rem;\n  color: #e5e7eb;\n  margin: 0 0 0.4rem;\n  line-height: 1.4;\n}\n\n.bug-question-type-tag {\n  display: inline-block;\n  padding: 0.1rem 0.4rem;\n  font-size: 0.65rem;\n  font-weight: 600;\n  color: #60a5fa;\n  background: rgba(96, 165, 250, 0.1);\n  border: 1px solid rgba(96, 165, 250, 0.2);\n  border-radius: 4px;\n  margin-bottom: 0.4rem;\n}\n\n.bug-question-options {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-top: 0.3rem;\n}\n\n.bug-question-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.35rem;\n  padding: 0.25rem 0.4rem;\n  border-radius: 5px;\n  font-size: 0.75rem;\n  color: #9ca3af;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.bug-question-option.correct {\n  background: rgba(34, 197, 94, 0.08);\n  border-color: rgba(34, 197, 94, 0.2);\n  color: #22c55e;\n}\n\n.bug-question-option.wrong {\n  background: rgba(239, 68, 68, 0.08);\n  border-color: rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n}\n\n.bug-question-option-letter {\n  font-weight: 700;\n  min-width: 1rem;\n  flex-shrink: 0;\n}\n\n.bug-question-meta {\n  margin-top: 0.35rem;\n  font-size: 0.72rem;\n  color: #6b7280;\n}\n\n.bug-q-correct { color: #22c55e; }\n.bug-q-incorrect { color: #ef4444; }\n\n/* ===================== Hamburger Button ===================== */\n.hamburger-btn {\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 44px;\n  height: 44px;\n  background: none;\n  border: none;\n  color: #ffffff;\n  cursor: pointer;\n  gap: 5px;\n  padding: 0;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.hamburger-line {\n  display: block;\n  width: 20px;\n  height: 2px;\n  background: currentColor;\n  border-radius: 1px;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n/* Animate to X when open */\n.hamburger-btn.open .hamburger-line:nth-child(1) {\n  transform: translateY(7px) rotate(45deg);\n}\n\n.hamburger-btn.open .hamburger-line:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger-btn.open .hamburger-line:nth-child(3) {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n/* ===================== Mobile Menu Backdrop ===================== */\n.mobile-menu-backdrop {\n  display: none;\n}\n\n/* ===================== Mobile-Only Elements ===================== */\n.mobile-menu-only {\n  display: none;\n}\n\n/* ===================== Mobile Responsive ===================== */\n@media (max-width: 768px) {\n  .top-nav-container {\n    padding: 0 1rem;\n  }\n\n  .hamburger-btn {\n    display: flex;\n  }\n\n  .logo-bono {\n    display: none;\n  }\n\n  .mobile-menu-only {\n    display: flex;\n  }\n\n  .top-nav-center {\n    position: fixed;\n    inset: 0;\n    top: 64px;\n    background: rgba(10, 10, 10, 0.98);\n    backdrop-filter: blur(20px);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.6);\n    flex-direction: column;\n    padding: 1.5rem;\n    padding-bottom: 1rem;\n    gap: 0.5rem;\n    z-index: 999;\n    display: none;\n    margin-left: 0;\n    justify-content: flex-start;\n    align-items: stretch;\n    bottom: auto;\n  }\n\n  .top-nav-center.mobile-menu-open {\n    display: flex;\n  }\n\n  .nav-link {\n    min-height: 48px;\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    font-size: 1.1rem;\n    padding: 0.75rem 1rem;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 0;\n  }\n\n  .nav-link svg {\n    color: #6b7280;\n    flex-shrink: 0;\n  }\n\n  .nav-link.active::after {\n    display: none;\n  }\n\n  .mobile-menu-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    top: 64px;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 998;\n  }\n\n  .upgrade-button,\n  .premium-badge {\n    padding: 0.4rem 0.6rem;\n    font-size: 0.75rem;\n    margin-right: 0.25rem;\n  }\n\n  .bug-report-nav-button {\n    width: 32px;\n    height: 32px;\n    min-width: 32px;\n    min-height: 32px;\n  }\n\n  .bug-report-nav-button svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n/* ─── Septyx dev admin entry (dev4 only) ─────────── */\n.nav-link--septyx {\n  position: relative;\n  color: rgba(239, 68, 68, 0.9) !important;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.nav-link--septyx::before {\n  content: '';\n  position: absolute;\n  left: 6px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: rgba(239, 68, 68, 0.9);\n  box-shadow: 0 0 6px rgba(239, 68, 68, 0.7);\n}\n\n.nav-link--septyx {\n  padding-left: 18px !important;\n}\n\n.nav-link--septyx:hover {\n  color: rgba(254, 202, 202, 1) !important;\n  background: rgba(239, 68, 68, 0.08);\n}\n\n.nav-link--septyx.active {\n  color: rgba(254, 202, 202, 1) !important;\n  background: rgba(239, 68, 68, 0.12);\n  border-color: rgba(239, 68, 68, 0.4);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
